import Reveal from "./Reveal";

/**
 * A snaking dashed "wire" with a glowing numbered bubble that links sections
 * into a connected journey (1 → 2 → 3 …). It spans the existing gap between
 * sections and is pulled in with negative margins so it adds NO extra height.
 * Pure SVG + CSS; honours prefers-reduced-motion globally.
 */
export default function SectionConnector({ number, flip = false }) {
  const d = flip
    ? "M110 2 C 184 70, 36 154, 110 222"
    : "M110 2 C 36 70, 184 154, 110 222";
  return (
    <Reveal
      direction="none"
      amount={0.3}
      className="pointer-events-none relative z-10 -my-28 flex justify-center"
    >
      <svg width="240" height="224" viewBox="0 0 220 224" className="overflow-visible" aria-hidden="true">
        <defs>
          <linearGradient id={`wire-${number}`} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="#22d3ee" />
            <stop offset="0.5" stopColor="#8b5cf6" />
            <stop offset="1" stopColor="#ec4899" />
          </linearGradient>
          <radialGradient id={`bub-${number}`} cx="0.5" cy="0.38" r="0.7">
            <stop offset="0" stopColor="#a78bfa" />
            <stop offset="1" stopColor="#6d28d9" />
          </radialGradient>
        </defs>

        <path
          d={d}
          fill="none"
          stroke={`url(#wire-${number})`}
          strokeWidth="2.5"
          strokeDasharray="1 11"
          strokeLinecap="round"
          className="sc-flow"
        />

        <g className="sc-bubble">
          <circle cx="110" cy="112" r="33" fill="none" stroke="#a78bfa" strokeOpacity="0.3" strokeWidth="1.5" strokeDasharray="3 6" className="sc-ring" />
          <circle cx="110" cy="112" r="25" fill={`url(#bub-${number})`} style={{ filter: "drop-shadow(0 0 12px rgba(139,92,246,0.55))" }} />
          <circle cx="110" cy="112" r="25" fill="none" stroke="#ffffff22" strokeWidth="1.5" />
          <text x="110" y="121" textAnchor="middle" fontSize="25" fontWeight="700" fill="#ffffff" fontFamily="'Space Grotesk',system-ui,sans-serif">
            {number}
          </text>
        </g>
      </svg>
    </Reveal>
  );
}
